import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=25c2e8cf&scoped=true&"
import script from "./Root.vue?vue&type=script&lang=js&"
export * from "./Root.vue?vue&type=script&lang=js&"
import style0 from "./Root.vue?vue&type=style&index=0&id=25c2e8cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2e8cf",
  null
  
)

export default component.exports